import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac'
import { Roles } from '@/features/roles'

export const Route = createFileRoute('/_authenticated/roles/')({
  beforeLoad: async () => {
    const { auth } = useAuthStore.getState()

    // Check if user has permission to manage roles
    if (!auth.canAccess([PERMISSIONS.ROLES.READ])) {
      throw redirect({
        to: '/unauthorized',
      })
    }
  },
  component: Roles,
})
